import { render } from "./Index.vue?vue&type=template&id=29e64226&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=29e64226&scoped=true&lang=css"

import exportComponent from "D:\\projects\\bihua-portals\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29e64226"]])

export default __exports__